import { UI } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Stack } from 'native-base';
import React from 'react';
import { FlatList } from 'react-native';

import { PublicOfferDetailsModalityNormalized } from '../../../../../../../../../../../store/product/types';

export interface PublicOffersModalityProps {
  modality: PublicOfferDetailsModalityNormalized;
  isMobile: boolean;
}

export const PublicOffersModality: React.FC<PublicOffersModalityProps> = ({
  modality,
  isMobile,
}) => {
  const data = [
    { label: 'Nome Modalidade', value: modality.modalityName },
    { label: 'Descrição Modalidade', value: modality.modalityDescription },
    { label: 'Tipo', value: modality.modalityType },
    { label: 'Início Reserva', value: modality.reservationStartDateFormatted },
    { label: 'Fim Reserva', value: modality.reservationEndDateFormatted },
    { label: 'Valor Max Adesão', value: modality.maximumApplicationFormatted },
    { label: 'Valor Min Adesão', value: modality.minimumApplicationFormatted },
  ];
  return (
    <FlatList
      key={`${modality.modalityName}-${isMobile}`}
      style={{ overflow: 'visible' }}
      columnWrapperStyle={
        isMobile
          ? undefined
          : {
              paddingVertical: Utils.Token.ToInt(Spacing, 'stack.nano'),
            }
      }
      data={data}
      renderItem={({ item }) => (
        <Stack
          direction={isMobile ? 'row' : 'column'}
          space={Spacing['stack.quarck']}
          w={isMobile ? 'full' : '1/4'}
          justifyContent={isMobile ? 'space-between' : 'flex-start'}
          pb={isMobile ? Spacing['stack.quarck'] : undefined}>
          <UI.Text variant="semibold" fontSize={Typography['fontsize.xs']}>
            {item.label}
          </UI.Text>
          <UI.Text>{item.value}</UI.Text>
        </Stack>
      )}
      numColumns={isMobile ? 1 : 4}
    />
  );
};
